import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { linkHoverColor } from "@faire/retailer-visitor-shared/components/Header/Colors";
import { HeaderLinkBase } from "@faire/retailer-visitor-shared/components/Header/HeaderLinkBase";
import { AccessibilityLinkCss } from "@faire/retailer-visitor-shared/lib/AccessibilityLink";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { Button } from "@faire/web--source/slate/Button";
import { VerticalLine } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import classNames from "classnames";
import * as React from "react";
import styled, { css } from "styled-components";
export var SMALL_LOGO_WIDTH = 320;
export var MAX_HEADER_WIDTH = 1920;
export var HeaderIconContainer = styled.div.withConfig({
    componentId: "sc-82a1d77f-0"
})([
    "width:40px;position:relative;display:flex;align-items:center;justify-content:center;",
    "{width:32px;}"
], responsiveMediaQueries.desktopAndAbove);
export var HeaderItemCss = css([
    "",
    ";display:flex;align-items:center;justify-content:center;height:60px;padding:0 12px;cursor:pointer;transition:color 0.1s linear;white-space:nowrap;",
    " &:hover{color:",
    ";}",
    "{height:",
    ";",
    ";}"
], TypographyStyles({
    as: undefined
}), AccessibilityLinkCss, linkHoverColor, responsiveMediaQueries.mobile, function() {
    return isLoggedInRetailer() ? "30px" : "50px";
}, function() {
    return isLoggedInRetailer() ? "margin-top: 12px" : undefined;
});
export var HeaderLink = styled(HeaderLinkBase).withConfig({
    componentId: "sc-82a1d77f-1"
})([
    "",
    ";"
], HeaderItemCss);
export var HeaderAnchor = styled(Anchor).withConfig({
    componentId: "sc-82a1d77f-2"
})([
    "",
    ";"
], HeaderItemCss);
export var HeaderButton = styled(Button).attrs({
    variant: "primary"
}).withConfig({
    componentId: "sc-82a1d77f-3"
})([
    "height:36px;padding:0 20px;margin:0 12px;white-space:nowrap;width:max-content;",
    "{",
    " margin-left:0;margin-right:12px;padding:0 10px;height:32px;}"
], responsiveMediaQueries.mobile, TypographyStyles({
    variant: "labelSansRegular",
    color: "white"
}));
var getHeaderLinkPadding = function(screenWidth) {
    if (screenWidth == null) {
        return getSpacing(0, "2x");
    } else if (0 <= screenWidth && screenWidth <= SMALL_LOGO_WIDTH) {
        return getSpacing(0, "1x");
    } else {
        return getSpacing(0, "2x");
    }
};
export var HeaderLinkButton = styled.button.withConfig({
    componentId: "sc-82a1d77f-4"
})([
    "",
    ";padding:",
    ";position:relative;"
], HeaderItemCss, function(param) {
    var $width = param.$width;
    return getHeaderLinkPadding($width);
});
export var HeaderLine = styled(VerticalLine).attrs({
    height: "24px",
    color: Core.border.subdued,
    margin: "0 15px"
}).withConfig({
    componentId: "sc-82a1d77f-5"
})([
    ""
]);
export var HeaderDropdown = styled.div.withConfig({
    componentId: "sc-82a1d77f-6"
})([
    "position:absolute;width:",
    ";",
    " background:white;top:60px;right:",
    ";",
    ";box-shadow:",
    ";z-index:1;"
], function(props) {
    return props.$width ? props.$width : "250px";
}, function(props) {
    return props.$maxHeight ? css([
        "max-height:",
        ";overflow:auto;"
    ], props.$maxHeight) : "";
}, function(props) {
    return props.$right ? props.$right : "5px";
}, function(props) {
    return props.$left ? css([
        "left:",
        ";"
    ], props.$left) : "";
}, function(props) {
    return props.$noBoxShadow ? "none" : "0 1px 20px rgba(0, 0, 0, 0.1)";
});
var HeaderContainerBase = styled.header.withConfig({
    componentId: "sc-82a1d77f-7"
})([
    "width:100%;display:flex;flex-direction:column;align-items:stretch;background:",
    ";z-index:",
    ";border-bottom:1px solid ",
    ";transition:background 0.1s linear;position:relative;flex:0 0 auto;&.isAdmin{border-bottom:3px solid blue !important;box-sizing:border-box;}&.impersonating{border-bottom:3px solid lime !important;box-sizing:border-box;}@media print{display:none;}"
], Core.surface.inverse, function(props) {
    return props.$zIndex;
}, Core.border.muted);
export var HeaderContainer = function(_param) {
    var ref = _param.ref, props = _object_without_properties(_param, [
        "ref"
    ]);
    var user = useUserStore([
        "user"
    ]).user;
    var className = classNames({
        impersonating: user === null || user === void 0 ? void 0 : user.impersonating,
        isAdmin: user === null || user === void 0 ? void 0 : user.is_employee
    }, props.className);
    return /*#__PURE__*/ _jsx(HeaderContainerBase, _object_spread_props(_object_spread({}, props), {
        className: className,
        $zIndex: 301,
        ref: ref,
        children: props.children
    }));
};
